export default "__VITE_ASSET__Cki4ejqu__"